import axios from 'axios';
import config from '../config/config.json';

const ratingPost = (url: string, rating: number, captchaToken: string): void => {
    axios.post(config.ratingApiUrl.POST_RATING, { url, rating, captchaToken });
};

export default ratingPost;
